document.addEventListener('click', function (e) {
    if (!e.target.closest('#btnAgregarEntregaLineaSoplado')) return;

    const inputId = document.getElementById('idReporteSopladoAgregarLinea');
    const fuente  = document.getElementById('idReporteSoplado');
    if (inputId && fuente) inputId.value = fuente.value;
});

document.addEventListener('submit', function (e) {
    const form = e.target.closest('#formAgregarEntregaLineaSoplado');
    if (!form) return;
    e.preventDefault();

    modal = form.closest('.modal');

    const btnSubmit = form.querySelector('[type="submit"]');
    if (btnSubmit) btnSubmit.disabled = true;

    const data = new FormData(form);

    fetch('/api/soplado/agregar-entrega-linea', {
        method: 'POST',
        credentials: 'include',
        body: data
    })
    .then(r => r.json())
    .then(json => {
        const errores = json.result.errores ?? [];
        errores.forEach(e => {
            lanzarAlerta(e.mensaje, e.clase);
            const campo = form.querySelector('[name="' + e.campo + '"]');
            if (campo) campo.classList.add('inputRojo');
        });

        if (!json.result.hayErrores) {
            const idReporte = document.getElementById('idReporteSopladoAgregarLinea').value;
            form.reset();
            modal.classList.remove('modal--show');
            if (idReporte && typeof window.actualizarTablaEntregaLinea === 'function') {
                window.actualizarTablaEntregaLinea(idReporte);
            }
            if (typeof window.actualizarModalReporteSoplado === 'function') {
                window.actualizarModalReporteSoplado(idReporte);
            }
            if (typeof window.actualizarBalanceSoplado === 'function') {
                window.actualizarBalanceSoplado(idReporte);
            }
            lanzarAlerta('Registro de unidades en línea agregado exitosamente.', 'alerta-verde');
        }
    })
    .catch(() => lanzarAlerta('Error al conectar con el servidor.', 'alerta-roja'))
    .finally(() => { if (btnSubmit) btnSubmit.disabled = false; });
});
